@if (allMedications) {
<mat-card class="profile-card px-15 pb-20">
    <mat-card-header>
        <mat-card-title>
            <div class="g-just-flex gap-8">
                <div class="round-icon-wrapper contrast">
                    <mat-icon>
                        medication
                    </mat-icon>
                </div>
                <span> Medication</span>
            </div>
        </mat-card-title>

    </mat-card-header>
    <mat-card-content>
        <div class="my-10">
            <mat-divider>

            </mat-divider>
            <div class="my-20"></div>
            <div class="g-just-flex special-header-wrapper  my-20 mb-30 gap-18"
                style="justify-content: space-between; flex-wrap: wrap;">

                <div class="special-header g-just-flex gap-15" style="align-items: flex-start; ">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                            fill="var(--mat-sys-on-surface)">
                            <path
                                d="M345-120q-94 0-159.5-65.5T120-345q0-45 17-86t49-73l270-270q32-32 73-49t86-17q94 0 159.5 65.5T840-615q0 45-17 86t-49 73L504-186q-32 32-73 49t-86 17Zm266-286 107-106q20-20 31-47t11-56q0-60-42.5-102.5T615-760q-29 0-56 11t-47 31L406-611l205 205ZM345-200q29 0 56-11t47-31l106-107-205-205-107 106q-20 20-31 47t-11 56q0 60 42.5 102.5T345-200Z" />
                        </svg>

                    </div>

                    <div class="words g-just-flex flex-column gap-15"
                        style="align-items: flex-start; font-size: 1.1rem;">
                        <strong>
                            <em>
                                <span
                                    [innerHTML]="allMedications[0].medication | codeableReference : 'code':'coding':0:'display' | async "></span>

                            </em>

                        </strong>

                        <div class="g-just-flex gap-20">
                            <div #sc
                                [attr.class]="'small-chips'+' '+'status-'+statuStyles[allMedications[0].status]['color']+' g-just-flex gap-8'">

                                <span> {{allMedications[0].status}}

                                </span>
                                <mat-icon>
                                    {{statuStyles[allMedications[0].status]['icon']}}
                                </mat-icon>

                            </div>
                            <div #sc
                                [attr.class]="'small-chips'+' '+'status-'+intentStyles[allMedications[0].intent]['color']+' g-just-flex gap-8'">


                                <span> {{allMedications[0].intent}}

                                </span>
                                <mat-icon>
                                    {{intentStyles[allMedications[0].intent]['icon']}}
                                </mat-icon>

                            </div>
                        </div>

                        @if(allMedications[0].substitution){
                        @if(allMedications[0].substitution.allowedBoolean){
                        <div #sc [attr.class]="'small-chips'+' '+'status-green'+' g-just-flex gap-8'">


                            <span>
                                No Substitution
                            </span>

                            <mat-icon>
                                check_circle
                            </mat-icon>



                        </div>}@else {
                        <div #sc [attr.class]="'small-chips'+' '+'status-red'+' g-just-flex gap-8'">


                            <span>
                                Substitution Allowed

                            </span>

                            <mat-icon>
                                block
                            </mat-icon>



                        </div>

                        }
                        }


                        <!-- <a
                        href="{{allMedications[0].medication.reference && allMedications[0].medication.reference.reference? allMedications[0].medication.reference.reference:''}}">

                        {{allMedications[0].medication.concept?allMedications[0].medication.concept!.coding![0]!.display:
                        allMedications[0].medication.reference?.display
                        || allMedications[0].medication.reference?.reference ||
                        allMedications[0].medication.reference?.identifier
                        }}
                    </a> -->
                    </div>
                </div>
                <div class="action-button mb-15 gap-18" style="flex-wrap: wrap;">
                    <a mat-flat-button class=" header-group">
                        <mat-icon>assignment</mat-icon>
                        <span>Generate Order</span>
                    </a>
                    <a mat-flat-button class=" header-group" (click)="dispense(allMedications[0]);">
                        <mat-icon>local_pharmacy</mat-icon>
                        <span>Dispense</span>
                    </a>
                    <a mat-flat-button class=" header-group" (click)="administer(allMedications[0]);">
                        <mat-icon>vaccines</mat-icon>
                        <span>Administer</span>
                    </a>
                </div>
            </div>
            <div class="cards-wrapper">

                <mat-card>

                    <mat-card-header>
                        <div class="g-just-flex gap-15" style="
                    align-items: flex-start;
                    justify-content: flex-start; 
                    ">
                            <!-- <div class="header-icon">

                        </div> -->
                            <div class="header-words  ">
                                <div class="title-flex" class="g-just-flex gap-8" style="
                    align-items: flex-start;
                    justify-content: flex-start; 
                    ">
                                    <mat-icon>person</mat-icon> <mat-card-title>
                                        Actors</mat-card-title>
                                </div>
                                <!-- <mat-card-subtitle class="subtitle-text-color" style="font-size: 1rem;">
                                    Medicine Details
                                </mat-card-subtitle> -->
                            </div>
                        </div>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="my-10 mt-20">
                            <div class="my-10"></div>
                            <div class="card-content-details">
                                <div class="fields-wrapper g-just-flex gap-15">


                                    <div class="field-group">
                                        <div class="field-value">
                                            <div #sc class="value-with-icon">


                                                @let name =(allMedications[0].subject | Reference : 'name' |
                                                async);
                                                <span>
                                                    {{name[0]?.given[0]+" "+name[0]?.family}}
                                                </span>
                                                @if(allMedications[0].subject?.reference
                                                && !allMedications[0].subject?.identifier
                                                && !allMedications[0].subject?.display
                                                ){
                                                <a class="icon-link" [href]="allMedications[0].subject.reference "
                                                    style="height: max-content;">

                                                    <mat-icon>link</mat-icon>
                                                </a>
                                                }

                                            </div>
                                        </div>
                                        <div class="field-title">
                                            {{'to be used by' | titlecase}}
                                        </div>
                                    </div>
                                    @if(allMedications[4].encounter){
                                    <div class="field-group">
                                        <div class="field-value">
                                            <div #sc class="value-with-icon">


                                                @let encounter =(allMedications[4].encounter | Reference :
                                                'name' |
                                                async);
                                                <span>
                                                    {{encounter}}
                                                </span>
                                                @if(allMedications[0].encounter?.reference
                                                && !allMedications[0].encounter?.identifier
                                                && !allMedications[0].encounter?.display
                                                ){


                                                <a class="icon-link" [href]="allMedications[0].encounter?.reference "
                                                    style="height: max-content;">

                                                    <mat-icon>link</mat-icon>
                                                </a>
                                                }

                                            </div>
                                        </div>
                                        <div class="field-title">
                                            {{'Encounter / Consultation (When Requested)' | titlecase}}
                                        </div>
                                    </div>
                                    }




                                    @if(allMedications[4].requester){
                                    <div class="field-group">
                                        <div class="field-value">
                                            <div #sc class="value-with-icon">


                                                @let encounter =(allMedications[4].requester | Reference :
                                                'name' |
                                                async);
                                                <span>
                                                    {{encounter}}
                                                </span>
                                                @if(allMedications[0].requester?.reference
                                                && !allMedications[0].requester?.identifier
                                                && !allMedications[0].requester?.display
                                                ){


                                                <a class="icon-link" [href]="allMedications[0].requester?.reference "
                                                    style="height: max-content;">

                                                    <mat-icon>link</mat-icon>
                                                </a>
                                                }

                                            </div>
                                        </div>
                                        <div class="field-title">
                                            {{'Who is the requester (Doctor | Pharmacist)' | titlecase}}
                                        </div>
                                    </div>
                                    }

                                    @if(allMedications[4].performer){
                                    @for(eachPerformer of allMedications[4].performer; track $index;){


                                    <div class="field-group">
                                        <div class="field-value">
                                            <div #sc class="value-with-icon">


                                                @let encounter =(eachPerformer | Reference :
                                                'name' |
                                                async);
                                                <span>
                                                    {{encounter}}
                                                </span>
                                                @if(eachPerformer?.reference
                                                && !eachPerformer?.identifier
                                                && !eachPerformer?.display
                                                ){


                                                <a class="icon-link" [href]="allMedications[0].requester?.reference "
                                                    style="height: max-content;">

                                                    <mat-icon>link</mat-icon>
                                                </a>
                                                }

                                            </div>
                                        </div>
                                        <div class="field-title">
                                            {{'Med. Administration Peformer' | titlecase}}
                                        </div>
                                    </div>
                                    }
                                    }

                                    @if(allMedications[4].performerType){
                                    <div class="field-group">
                                        <div class="field-value">
                                            <div #sc class="value-with-icon">


                                                @let performerType =(allMedications[4].performerType |
                                                codeableConceptLabel);
                                                <span [innerHTML]="performerType">
                                                    <!-- {{performerType}} -->
                                                </span>


                                            </div>
                                        </div>
                                        <div class="field-title">
                                            {{'Performer Type' | titlecase}}
                                        </div>
                                    </div>
                                    }




                                    @if(allMedications[4].recorder){
                                    @let recorder = allMedications[4].recorder;
                                    <div class="field-group">
                                        <div class="field-value">
                                            <div #sc class="value-with-icon">


                                                @let encounter =(recorder | Reference :
                                                'name' |
                                                async);
                                                <span>
                                                    {{encounter}}
                                                </span>
                                                @if(recorder?.reference
                                                && !recorder?.identifier
                                                && ! recorder?.display
                                                ){


                                                <a class="icon-link" [href]="allMedications[0].recorder?.reference "
                                                    style="height: max-content;">

                                                    <mat-icon>link</mat-icon>
                                                </a>
                                                }

                                            </div>
                                        </div>
                                        <div class="field-title">
                                            {{'Recorder' | titlecase}}
                                        </div>
                                    </div>
                                    }

                                    @if(allMedications[4].reason){
                                    <div class="field-group">
                                        @for (reason of allMedications[4].reason; track $index) {
                                        <div class="field-value">
                                            <div #sc class="value-with-icon">


                                                @let reasonDisplay = reason | codeableReference :'code': 'Coding' :0
                                                :'display' | async;
                                                <span>
                                                    {{reasonDisplay}}
                                                </span>


                                            </div>
                                        </div>
                                        <div class="field-title">
                                            {{'Recorder' | titlecase}}
                                        </div>
                                        }
                                    </div>

                                    }




                                    <!-- 
                                    <div class="field-group">
                                        <div class="field-value">
                                            <div #sc
                                                [attr.class]="'small-chips'+' '+'status-'+intentStyles[allMedications[0].intent]['color']+' g-just-flex gap-8'">


                                                <span> {{allMedications[0].intent}}

                                                </span>
                                                <mat-icon>
                                                    {{intentStyles[allMedications[0].intent]['icon']}}
                                                </mat-icon>

                                            </div>
                                        </div>
                                        <div class="field-title">
                                            {{'Intent' | titlecase}}
                                        </div>
                                    </div> -->

                                </div>
                            </div>
                        </div>
                    </mat-card-content>


                </mat-card>

                @if((allMedications[4].dosageInstruction && allMedications[4].dosageInstruction.length >0) ||
                allMedications[4].renderedDosageInstruction || allMedications[4].effectiveDosePeriod
                ){


                <mat-card>

                    <mat-card-header>
                        <div class="g-just-flex gap-15" style="
                    align-items: flex-start;
                    justify-content: flex-start; 
                    ">
                            <!-- <div class="header-icon">

                        </div> -->
                            <div class="header-words  ">
                                <div class="title-flex" class="g-just-flex gap-8" style="
                    align-items: flex-start;
                    justify-content: flex-start; 
                    ">
                                    <mat-icon>medication</mat-icon> <mat-card-title>
                                        Dosage Instruction</mat-card-title>
                                </div>
                                <!-- <mat-card-subtitle class="subtitle-text-color" style="font-size: 1rem;">
                                    Medicine Details
                                </mat-card-subtitle> -->
                            </div>
                        </div>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="my-10 mt-20">
                            <div class="my-10"></div>
                            <div class="card-content-details">
                                <div class="fields-wrapper g-just-flex gap-15">

                                    @if(allMedications[0].renderedDosageInstruction){
                                    <div class="field-group">
                                        <div class="field-value"
                                            [innerHTML]="allMedications[0].renderedDosageInstruction">

                                        </div>
                                        <div class="field-title">
                                            General Dosage Instruction
                                        </div>
                                    </div>
                                    }

                                    @if(allMedications[0].effectiveDosePeriod){
                                    <div class="field-group">
                                        <div class="field-value" [innerHTML]="allMedications[0].effectiveDosePeriod">

                                        </div>
                                        <div class="field-title">
                                            Period to Take Medicine
                                        </div>
                                    </div>
                                    }



                                    @if(allMedications[0].dosageInstruction){
                                    @let sortedDose = sortAccordingToSequence(allMedications[0].dosageInstruction);
                                    @for(instruction of sortedDose; track $index;){
                                    @if(instruction.patientInstruction){

                                    <div class="field-group">
                                        <div class="field-value" [innerHTML]="instruction.patientInstruction">

                                        </div>
                                        <div class="field-title">
                                            Patient Instruction
                                        </div>
                                    </div>
                                    }
                                    @else if(instruction.text){
                                    <div class="field-group">
                                        <div class="field-value" [innerHTML]="instruction.text">

                                        </div>
                                        <div class="field-title">
                                            Dosage Insructions In Text
                                        </div>
                                    </div>
                                    }
                                    @else {
                                    <div class="other-details">
                                        @for(key of fieldKeys(instruction,
                                        ['patientInstruction', 'text']); track $index;){

                                        <div class="field-group">
                                            <div class="field-value" [innerHTML]="renderOtherFields(instruction, key)">

                                            </div>
                                            <div class="field-title">
                                                {{key | titlecase}}
                                            </div>
                                        </div>
                                        }
                                    </div>
                                    }
                                    }

                                    }

                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                }
                @if(allMedications[0].dispenseRequest &&
                allMedications[0].dispenseRequest?.dispenserInstruction){
                <mat-card>

                    <mat-card-header>
                        <div class="g-just-flex gap-15" style="
                    align-items: flex-start;
                    justify-content: flex-start; 
                    ">
                            <!-- <div class="header-icon">

                        </div> -->
                            <div class="header-words  ">
                                <div class="title-flex" class="g-just-flex gap-8" style="
                    align-items: flex-start;
                    justify-content: flex-start; 
                    ">
                                    <mat-icon>medication</mat-icon> <mat-card-title>
                                        Dispenser</mat-card-title>
                                </div>
                                <!-- <mat-card-subtitle class="subtitle-text-color" style="font-size: 1rem;">
                                    Medicine Details
                                </mat-card-subtitle> -->
                            </div>
                        </div>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="my-10 mt-20">
                            <div class="my-10"></div>
                            <div class="card-content-details">
                                <div class="fields-wrapper g-just-flex gap-15">

                                    @if(allMedications[0].dispenseRequest &&
                                    allMedications[0].dispenseRequest?.dispenserInstruction){
                                    <div class="field-group">
                                        <div class="field-value"
                                            [innerHTML]="allMedications[0].dispenseRequest?.dispenserInstruction">

                                        </div>
                                        <div class="field-title">
                                            Dispenser Instruction
                                        </div>
                                    </div>
                                    }


                                </div>




                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                }
            </div>
        </div>
    </mat-card-content>
</mat-card>}